export default "__VITE_ASSET__zPzXoYVP__"